// src/components/ArticleCard.js
// import React from 'react';
import '../styles/ArticleCard.css'; // Custom styles for additional tweaks

import { useState, useEffect } from "react";

const ArticleCard = ({ article }) => {
  const imageUrl = article.images;

  const [likeCount, setLikeCount] = useState(0);
  const [liked, setLiked] = useState(false); // track like state

  const [likeCount1, setLikeCount1] = useState(0);
  const [liked1, setLiked1] = useState(false); // track like state

  useEffect(() => {
    const initialLikes = Math.floor(Math.random() * 91) + 10; // 10 to 100
    setLikeCount(initialLikes);

    const initialLikes1 = Math.floor(Math.random() * 91) + 10; // 10 to 100
    setLikeCount1(initialLikes1);
  }, []);

  const handleLikeToggle = () => {
    if (liked) {
      setLikeCount((prev) => prev - 1);
    } else {
      setLikeCount((prev) => prev + 1);
    }
    setLiked(!liked);
  };

  const handleLikeToggle1 = () => {
    if (liked1) {
      setLikeCount1((prev) => prev - 1);
    } else {
      setLikeCount1((prev) => prev + 1);
    }
    setLiked1(!liked1);
  };

  return (
    <article className="article-card">
      <div className="article-container">
        {/* Image Section */}
        <div className="article-image-container">
          <img
            src={imageUrl}
            alt={`${article.content["heading"]} image`}
            loading="lazy"
            className="article-image"
          />
          <p className="article-date-label">
            {new Date(article.created_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>

        {/* Text Content Section */}
        <div className="article-text-container">
          <span className="article-label">{article.content["labels"]}</span>
          <h2 className="article-heading">{article.content["heading"]}</h2>
          <p className="article-context">{article.content["news-context"]}</p>

          {/* Polls Section */}
          <div className="poll-section">
            {/* Poll 1 */}
            <div className="poll-container1 poll-left">
              <h3 className="poll-title">Poll 1:</h3>
              <p className="poll-description">
                {article.content["long-summary-left-leaning"]}
              </p>
              <div className="poll-actions">
                <div className="poll-buttons">
                <button
              className={`article-action-btn like-btn ${liked ? "liked" : ""}`}
              onClick={handleLikeToggle}
              // style={{ color: liked ? "red" : "inherit" }}
                >
                <i className={"fas fa-arrow-up"}></i> {likeCount}
                </button>
                  <button className="poll-comment">
                    <i className="far fa-comment"></i>
                  </button>
            
                </div>
                <button className="article-action-btn">
                <i className="fas fa-link"></i>  Show Source
                </button>
              </div>
            </div>

            {/* Poll 2 */}
            <div className="poll-container2 poll-right">
              <h3 className="poll-title">Poll 2:</h3>
              <p className="poll-description">
                {article.content["short-summary-right-leaning"]}
              </p>
              <div className="poll-actions">
                <div className="poll-buttons">
                <button
              className={`article-action-btn like-btn ${liked1 ? "liked" : ""}`}
              onClick={handleLikeToggle1}
              // style={{ color: liked ? "red" : "inherit" }}
                >
                  <i className={"fas fa-arrow-up"}></i> {likeCount1}
                </button>
                  <button className="poll-comment">
                    <i className="far fa-comment"></i>
                  </button>
            
                </div>
                <button className="article-action-btny">
                <i className="fas fa-link"></i>  Show Source
                </button>
              </div>
            </div>
          </div>
          <button className="article-action-btn">
              <i className="fas fa-share-alt"></i> Share
          </button>
      </div>
        </div>
        
    </article>
  );
};
export default ArticleCard;